/*
 * Copyright (c) 2020.
 * Simon
 */

import {SERVER_API_PLATFORMJK} from '../../constans/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";
import {
    HEAR_CREATE_FAILURE,
    HEAR_CREATE_REQUEST,
    HEAR_CREATE_SUCCESS
} from "../../types/index";

/**
 * HearCreateAction
 */
const HearCreateAction = (hearData, fanpageId, actor) => ({

    [RSAA]: {
        endpoint: () => {
            return `${SERVER_API_PLATFORMJK}/api/hears`
        },
        method: "POST",
        headers: (headers()),
        body: (() => {
            return JSON.stringify(hearData);
        }),
        types: [
            HEAR_CREATE_REQUEST,
            {
                type: HEAR_CREATE_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "actor": actor,
                        "type": HEAR_CREATE_SUCCESS,
                        "fanpage_id": fanpageId,
                        "data": data,
                    }
                }
            },
            {
                type: HEAR_CREATE_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": HEAR_CREATE_FAILURE,
                        "actor": actor,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }
});

export {HearCreateAction}

